import { useParams } from 'react-router';
/**
 * @returns the packageId from the current route (url) or null if it is not present.
 */
export const usePackageIdOrNull = () => {
    const { packageId } = useParams();
    return packageId ?? null;
};
